<script setup>
import { ref, reactive } from "vue";
import ImageUpload from "./imageUpload.vue";
import {
  queryCompanyInfo,
  queryCompanyStock,
  queryCompanyCertificates,
  queryCompanyContracts,
  queryStationInfoByOrgId,
} from "@/api/companyBaseInfo";
import { parseTime } from "@/utils/common";
import axios from "axios";

const props = defineProps(["deptId"]);

// 弹窗title
const dialogTitle = ref("");

// 弹窗控制
const visible = ref(false);

// 路径
const apiBaseUrl = process.env.VUE_APP_OPERATE_URL;

// 数据对象
const dataInfo = ref({});

//图片路径
const promotional = ref("");

// 组织架构数据
const flowChartList = ref([]);

// 股权架构列表
const stockList = ref([]);

// 证件列表
const certificateList = ref([]);

// 合同信息
const plantsContractList = ref([]);

// 厂站信息
const plantsBaseInfoList = ref([]);

// 控制展开更多的显示与隐藏
const isShowMore = ref(false);

// 框中内容的高度
const textHeight = ref(null);

// 内容状态是否打开
const status = ref(false);

//内容展开高度
const openTextHeight = ref(undefined);

//图片预览弹窗
const openImgDialog = ref(false);

// 图片数组
const imgPreviewList = ref([]);

//组织架构渲染
// number  charger orgName 根据数据结构中的字段名设置
// const renderContent = (h, data) => {
//   return (
//     <div class="organizational">
//       <div class="top">
//         <div class="organizational-label">
//           <span>
//             {data.number ? `${data.orgName}${data.number}人` : data.orgName}
//           </span>
//         </div>
//         <div class="organizational-name">
//           <span>{data.charger ? `(${data.charger})` : ""}</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// 获取股权架构
const getStock = () => {
  queryCompanyStock({
    deptId: props.deptId,
    page: 1,
    limit: 9999,
  }).then((res) => {
    stockList.value = res.data.records;
  });
};

// 获取证件列表
const getCertificateList = () => {
  queryCompanyCertificates({
    deptId: props.deptId,
    page: 1,
    limit: 9999,
  }).then((res) => {
    certificateList.value = res.data.records;
  });
};

// 获取合同列表
const getContract = () => {
  queryCompanyContracts({
    deptId: props.deptId,
    page: 1,
    limit: 9999,
  }).then((res) => {
    plantsContractList.value = res.data.records;
  });
};

// 获取公司下的所有厂站信息
const getStationInfoList = () => {
  queryStationInfoByOrgId(props.deptId).then((res) => {
    plantsBaseInfoList.value = res.data || [];
  });
};

//附件下载
const fileDownload = (id, name) => {};

// 图片路径改变
const changeImageSrc = (item, type) => {
  item.fileSrc = require(`@/assets/images/file-icon${type}.png`);
};

// 点击剩余年限
const setCompareRegistrationTimeText = (startDate, endDate) => {
  const date = new Date(startDate); // 转换时间格式
  const year = date.getFullYear(); // 取当年的年
  const month = date.getMonth() + 1; // 取当年的月(月份加一)
  const dd = date.getDate(); // 取当年的日期
  const nowDate = new Date(endDate); // 取现在的时间
  const nowYear = nowDate.getFullYear(); // 取现在的年
  const nowMonth = nowDate.getMonth() + 1; // 取现在的月(月份加一)
  const nowDd = nowDate.getDate(); // 取现在的日期
  /**
   * 日期计算(结束 - 开始)
   * 1-1当差值为正，就相差多少天
   * 1-1-1例如: (2021/3/15 - 2022/4/18) ===== 18-15 > 0 日期相差3天
   * 1-2当差值为负，计算从开始时间的日期到结束时间的日期相差几天
   * 1-2-1例如：(2021/3/15 - 2022/4/10) ===== 10-15 < 0
   * 其实就是计算从3/15 到 4、10号中间过了多少天
   * 1-2-1-1：方法： 其实就是计算3/15 到 3/31 号过了多少天，再加上 4月过的10天
   */
  const restDd =
    nowDd - dd < 0 ? lastDay(nowMonth - 1, year) - dd + nowDd : nowDd - dd;
  /**
   * 月份计算(结束 - 开始)
   * 1-1当差值为正，就相差多少月
   * 1-1-1例如: (2021/3/15 - 2022/4/18) ===== 4-3 > 0 月份相差1月
   * 1-2当差值为负，计算从开始时间的月份到结束时间的月份相差几天
   * 1-2-1例如：(2021/5/15 - 2022/4/10) ===== 4-5 < 0
   * 其实就是计算从5月到第二年4月过了多少月
   * 1-2-1-1：方法： 向年借一年为12月计算过了多少月
   */
  const restMonth =
    nowMonth - month < 0 ? 12 + nowMonth - month : nowMonth - month;
  /**
   * 年份计算(结束 - 开始)
   * 直接限制结束比开始大，只有0/正数
   */
  const restYear = nowYear - year;
  /**
   * 计算借位的问题
   */
  let resultMonth = restMonth;
  let resultYear = restYear;
  // 日期小说明借了月
  if (nowDd < dd) {
    resultMonth = restMonth - 1 < 0 ? restMonth - 1 + 12 : restMonth - 1;
  }
  // 月份小借了年 或者 日期小，月份刚好一致，因为日期借了月份，导致月份减1，所以减年
  if (nowMonth < month || (nowDd < dd && nowMonth === month)) {
    resultYear = restYear - 1;
  }
  // let str = {
  //     year: resultYear,
  //     month: resultMonth,
  //     day: restDd,
  // }
  return `${resultYear}年${resultMonth}月`;
};

/**
 * 判断每年的每个月的最后一天是几号
 * @param mo-月份
 * @param year-年份
 * @returns {number}
 */
const lastDay = (mo, year) => {
  if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
    return 30;
  } else if (mo === 2) {
    //2月
    if (this.isLeapYear(year)) {
      return 29;
    } else {
      return 28;
    }
  } else {
    //大月
    return 31;
  }
};

/**
 * 判断是否是闰年
 * @param Year-年份
 * @returns {boolean}
 */
const isLeapYear = (Year) => {
  return (Year % 4 === 0 && Year % 100 !== 0) || Year % 400 === 0;
};

//处理预览地址
const handlePre = (arr) => {
  return arr.map((m) => apiBaseUrl + m);
};

// //打开图片预览
const doPreImg = (urlList) => {
  imgPreviewList.value = urlList;
  openImgDialog.value = true;
};

//切换更多收起状态
const moreClick = () => {
  status.value = !status.value;
};

// 弹窗打开
const handleDialogOpen = () => {
  const id = props.deptId;
  queryCompanyInfo(id).then((res) => {
    dataInfo.value = res.data;
    axios
      .post(
        "/api/operate/file/preview",
        { reduceUrl: res.data.promotionalImage },
        { responseType: "blob" }
      )
      .then((response) => {
        promotional.value = window.URL.createObjectURL(response.data);
      });
  });
  getStock();
  getCertificateList();
  getContract();
  getStationInfoList();

  //   this.$nextTick(() => {
  //     // 这里具体行数可依据需求自定义
  //     let lineHeight = 19;
  //     this.textHeight = `${lineHeight}px`;
  //     this.openTextHeight = this.$refs.content.offsetHeight + "px";
  //     if (this.$refs.content.offsetHeight > lineHeight) {
  //       this.isShowMore = true;
  //       this.status = true;
  //     } else {
  //       this.isShowMore = false;
  //       this.status = false;
  //     }
  //   });
  // });

  visible.value = true;
};

// 将函数暴露给父组件
defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="dialogTitle"
    v-model="visible"
    width="60%"
    append-to-body
  >
    <div class="basic">
      <div class="basic-left">
        <img alt="" :src="promotional" />
      </div>
      <div class="basic-right">
        <div class="content">
          <el-row>
            <el-col :span="10">
              <div class="item">
                <span class="title">公司名称：</span>
                <span class="item-content">{{ dataInfo.companyName }}</span>
              </div>
            </el-col>
            <el-col :span="14">
              <div class="item">
                <span class="title">法人姓名：</span>
                <span class="item-content">{{ dataInfo.legalPersonName }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <div class="item">
                <span class="title">成立日期：</span>
                <span class="item-content">{{
                  dataInfo.dateOfEstablishment
                }}</span>
              </div>
            </el-col>
            <el-col :span="14">
              <div class="item">
                <span class="title">注册资金：</span>
                <span class="item-content"
                  >{{ dataInfo.registeredCapital }} 万元</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <div class="item">
                <span class="title">服务人口：</span>
                <span class="item-content">{{
                  dataInfo.servicePopulation
                }}</span>
              </div>
            </el-col>
            <el-col :span="14">
              <div class="item">
                <span class="title">经纬度：</span>
                <span class="item-content">{{
                  dataInfo.companyLongitude &&
                  dataInfo.companyDimension &&
                  dataInfo.companyLongitude + " , " + dataInfo.companyDimension
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <div class="item">
                <span class="title">员工人数：</span>
                <span class="item-content">{{ dataInfo.employeeNumber }}</span>
              </div>
            </el-col>
            <el-col :span="14">
              <div class="item">
                <span class="title">注册地址：</span>
                <span class="item-content">{{
                  dataInfo.companyRegisteredAddress
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="position: relative">
              <div
                ref="content"
                :style="{ 'max-height': status ? textHeight : openTextHeight }"
                :class="{ item: true, statusText: status }"
              >
                <span class="title">经营范围：</span>
                <span class="item-content">{{ dataInfo.businessScope }}</span>
              </div>
              <span class="more" @click="moreClick" v-if="isShowMore">{{
                status ? "更多..." : "收起"
              }}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="company-card">
      <div class="title">
        <div class="background1"></div>
        <div class="background2">
          <span>股权架构</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="com-content">
        <el-table
          :cell-style="{ fontSize: '12px' }"
          :data="stockList"
          border
          stripe
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="60"
          ></el-table-column>
          <el-table-column
            label="股东名称"
            align="center"
            prop="shareholderName"
            show-overflow-tooltip
          />
          <el-table-column
            label="占股比例(%)"
            align="center"
            prop="shareProportion"
            show-overflow-tooltip
          />
        </el-table>
      </div>
    </div>
    <div class="company-card">
      <div class="title">
        <div class="background1"></div>
        <div class="background2">
          <span>组织架构</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="com-content">
        <div class="orgTreeBox">
          <vue2-org-tree :data="flowChartList" :renderContent="renderContent" />
        </div>
      </div>
    </div>
    <div class="company-card">
      <div class="title">
        <div class="background1"></div>
        <div class="background2">
          <span>相关证件</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="com-content">
        <div class="doucment">
          <div
            class="document-card"
            v-for="item in certificateList"
            :key="item.id"
          >
            <img src="@/assets/images/documentIcon.png" />
            <div>
              <span>{{ item.name }}</span>
              <el-button style="display: block" type="primary" link
                >{{ item.fileName }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="company-card">
      <div class="title">
        <div class="background1"></div>
        <div class="background3">
          <span>项目合同表</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="com-content">
        <div
          class="contract-card"
          v-for="(item, index) in plantsContractList"
          :key="item.id"
          :style="index > 0 ? 'border-top:1px solid #ccc' : ''"
        >
          <div class="contracts-top">
            <div class="contracts-title">
              <img
                class="contracts-img"
                src="@/assets/images/image_32.png"
                alt=""
                align="absmiddle"
              />
              <span>{{ item.name }}</span>
            </div>
            <div
              v-if="item.files"
              class="contracts-files"
              @mouseenter="changeImageSrc(item, '-hover')"
              @mouseleave="changeImageSrc(item, '')"
            >
              <img class="file-icon" :src="item.fileSrc" alt="" />
              <span>{{ item.fileName }}</span>
            </div>
          </div>
          <el-row class="contracts-content">
            <el-col :span="4">
              <div class="contracts-label">商业模式</div>
              <div>{{ item.businessModel }}</div>
            </el-col>
            <el-col :span="4">
              <div class="contracts-label">合同对应期限</div>
              <div>{{ item.effectiveEndTime.substring(0, 10) }}</div>
            </el-col>
            <el-col :span="5">
              <div class="contracts-label">运营起止时间</div>
              <div>
                {{
                  item.effectiveStartTime.substring(0, 10) +
                  "至" +
                  item.effectiveEndTime.substring(0, 10)
                }}
              </div>
            </el-col>
            <el-col :span="3">
              <div class="contracts-label">剩余年限（年）</div>
              <div>
                {{
                  setCompareRegistrationTimeText(
                    parseTime(new Date(), "{y}-{m}-{d}"),
                    item.effectiveEndTime
                  )
                }}
              </div>
            </el-col>
            <el-col :span="4">
              <div class="contracts-label">合同甲方</div>
              <div>{{ item.firstParty }}</div>
            </el-col>
            <el-col :span="4">
              <div class="contracts-label">合作单位</div>
              <div>{{ item.cooperativeUnit }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="company-card">
      <div class="title">
        <div class="background1"></div>
        <div class="background2">
          <span>厂站项目</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="com-content">
        <el-table
          :cell-style="{ fontSize: '12px' }"
          :data="plantsBaseInfoList"
          border
          stripe
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="60"
          ></el-table-column>
          <el-table-column
            label="厂站名称"
            align="center"
            prop="name"
            width="200"
            show-overflow-tooltip
          />
          <el-table-column label="厂站性质" align="center">
            <template #default="{ row }">
              {{ row.operateType === "1" ? "委托运营" : "国润自营" }}</template
            >
          </el-table-column>
          <el-table-column
            label="已运营规模"
            align="center"
            prop="operatingScale"
            show-overflow-tooltip
          />
          <el-table-column
            label="协议规模"
            align="center"
            prop="agreementSize"
            show-overflow-tooltip
          />
          <el-table-column
            label="执行标准"
            align="center"
            prop="waterStandardName"
            show-overflow-tooltip
          />
          <el-table-column
            label="水价"
            align="center"
            prop="processingPrice"
            show-overflow-tooltip
          />
          <el-table-column
            label="工艺类型"
            align="center"
            prop="processingTechnology"
            show-overflow-tooltip
          />
          <el-table-column label="证件二维码" align="center">
            <template #default="{ row }">
              <div
                v-if="row.qrUrl.length > 0"
                class="my-pre"
                @click="doPreImg(row.qrUrl)"
              >
                <div class="qrText">查看</div>
                <img class="qrImg" src="@/assets/images/qrIcon.png" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="证件二维码"
      v-model="openImgDialog"
      width="30%"
      append-to-body
    >
      <imageUpload :imgBtnShow="false" :imgsBackTrain="imgPreviewList" />
    </el-dialog>
  </el-dialog>
</template>

<style lang="less" scoped>
.basic {
  display: flex;
  //height: 210px;
  width: 100%;

  .basic-left {
    flex: 1;

    img {
      width: 300px;
      height: 210px;
    }
  }

  .basic-right {
    flex: 3;
    background: #f6faff;
    border-radius: 4px;
    margin-left: 20px;
    width: 600px;
    /deep/ .el-row {
      margin: 16px;

      .item {
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;

        .title {
          color: #8c8c8c;
        }

        .item-content {
          color: #333333;
        }
      }
      .statusText {
        overflow: hidden;
      }
    }
  }
}

.company-card {
  margin-top: 16px;

  .title {
    height: 24px;
    position: relative;

    .background1 {
      position: absolute;
      left: 35px;
      bottom: 0;
      width: 107px;
      height: 16px;
      background: url("~@/assets/images/Rectangle1426.png") no-repeat center
        center;
      background-size: 100% 100%;
    }

    .background2 {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 85px;
      height: 24px;
      background: url("~@/assets/images/Rectangle4.png") no-repeat;
      background-size: 100% 100%;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #ffffff;

      span {
        position: absolute;
        left: 7px;
        bottom: 0;
      }
    }

    .background3 {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 101.5px;
      height: 24px;
      background: url("~@/assets/images/Rectangle6.png") no-repeat;
      background-size: 100% 100%;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #ffffff;

      span {
        position: absolute;
        left: 7px;
        bottom: 0;
      }
    }

    .line {
      position: absolute;
      left: 80px;
      bottom: 0;
      width: 93.5%;
      height: 1px;
      background-color: #3f78f7;
    }
  }

  .com-content {
    margin-top: 16px;
  }

  .doucment {
    display: flex;
    flex-wrap: wrap;

    .document-card {
      display: flex;
      align-items: center;
      box-shadow: 0px 3px 7px rgba(73, 87, 107, 0.15);
      border-radius: 4px;
      width: calc(100% / 4 - 24px);
      height: 102px;
      margin-right: 24px;
      margin-bottom: 16px;
      img {
        margin-left: 16px;
        width: 40px;
        height: 40px;
      }

      div {
        margin-left: 6px;

        span {
          font-weight: 600;
          color: #333333;
        }

        a {
          margin-top: 6px;
          color: rgba(0, 0, 0, 0.65);
        }
      }

      &:hover {
        cursor: pointer;
        box-shadow: 0px 9px 10px rgba(73, 87, 107, 0.15);

        a {
          color: #3f78f7;
        }
      }
    }
  }

  .contract-card {
    border: 1px solid #dde2eb;
    box-shadow: 0px 9px 10px rgba(73, 87, 107, 0.15);
    border-radius: 4px;
    height: 100px;
    margin-bottom: 16px;
  }
}

.orgTreeBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

@keyframes cardShadow {
  0% {
    box-shadow: 0px 3px 7px rgba(73, 87, 107, 0.15);
  }
  100% {
    box-shadow: 0px 9px 10px rgba(73, 87, 107, 0.15);
    color: red;
  }
}

.contracts-top {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .contracts-title {
    height: 33px;
    margin-top: 10px;
    line-height: 33px;

    .contracts-img {
      width: 24px;
      height: 24.91px;
      margin: 0 16px;
    }

    span {
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .contracts-files {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #f8f8f8;
    height: 24px;
    line-height: 24px;
    border-radius: 0px 3px;
    padding: 0px 6px;

    &:hover {
      cursor: pointer;
    }

    .file-icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }

  .contracts-files:hover {
    color: #3f78f7;
    background-color: #f1f6fe;
  }
}

.contracts-label {
  color: #8c8c8c;
  font-size: 14px;
  margin-bottom: 4px;
}

.contracts-content {
  padding: 8px 38px 12px 38px;
}

.my-img {
  display: none;
}

.my-pre {
  color: #3f78f7;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  .qrText {
    vertical-align: middle;
    line-height: 14px;
  }

  .qrImg {
    margin-left: 6px;
    width: 14px;
    height: 14px;
    vertical-align: middle;
  }
}
.more {
  color: #3f78f7;
  cursor: pointer;
  float: right;
  //position: absolute;
  //right: -40px;
  //top: 0;
}
</style>
